import { Link } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import '../css/flyers.scss';

// interface Props {
//   lightId: string;
//   lightName: string;
//   lightComment: string;
// }

// const renderIndicator = (
//   clickHandler: (e: React.MouseEvent | React.KeyboardEvent) => void,
//   isSelected: boolean,
//   index: number,
//   label: string
// ) => React.ReactNode;


const Flyers = () => (
  <div>
    <div className="flyers">
      <div>
        <Carousel 
        infiniteLoop={true} 
        showThumbs={false} 
        autoPlay={true} 
        emulateTouch={true} 
        swipeable={true}
        useKeyboardArrows={true}
        showStatus={false}
        // renderIndicator={renderIndicator}
        >

          <div id="grenouille" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/creacirque.jpg" alt="grenouille" />
                </div>
              </Link>
            </div>
          </div>
          <div id="cours" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/flyers/cours.jpg" alt="cours" />
                </div>
              </Link>
            </div>
          </div>
          <div id="crossfit" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/flyers/crossfit.png" alt="crossfit" />
                </div>
              </Link>
            </div>
          </div>
          <div id="annif" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/flyers/annif.jpg" alt="annif" />
                </div>
              </Link>
            </div>
          </div>
          <div id="monocycle" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/flyers/mono.png" alt="monocycle" />
                </div>
              </Link>
            </div>
          </div>
          <div id="general" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/flyers/general.jpg" alt="general" />
                </div>
              </Link>
            </div>
          </div>
          <div id="trampoline" className="carousel-item">
            <div className="content">
              <Link to="contact">
                <div className="inner-content">
                  <img id="scheduling-17983227" src="/images/flyers/trampo.png" alt="trampoline" />
                </div>
              </Link>
            </div>
          </div>
        </Carousel>
      </div>
    </div>

  </div>
  //onclick="openScheduling(17983227)"
);

export default Flyers;
